import { gql, useQuery } from "@apollo/client";
import { CompanyPolicyStatus } from "../../helper/constants";

export function useGetActivePolicies() {
  return useQuery(
    gql`
      query getActivePolicies($filter: FilterFindManyCompanyPolicyInput!) {
        company_policies(filter:$filter) {
          _id
          name
        }
      }
    `,
    {
      variables: {
        filter: {
          status: CompanyPolicyStatus.ACTIVE
        }
      },
      fetchPolicy : 'network-only'
    }
  );
}